import { useNavigate } from 'react-router-dom';
import { type ReactNode } from 'react';

interface SubHeaderProps {
  title: string;
  right?: ReactNode;
}

export default function SubHeader({ title, right }: SubHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-40 bg-brown-950 px-5 py-4 pt-safe flex items-center">
      <button
        onClick={() => navigate(-1)}
        className="w-8 h-8 flex items-center justify-center text-gold-400 cursor-pointer active:scale-90 transition-transform"
      >
        <i className="ri-arrow-left-line text-lg"></i>
      </button>
      <h1 className="text-gold-400 text-lg font-bold flex-1 text-center whitespace-nowrap">
        {title}
      </h1>
      <div className="w-8 h-8 flex items-center justify-center">{right}</div>
    </div>
  );
}